import {html, LitElement, TemplateResult} from "lit";
import {customElement, property} from "lit/decorators.js";
import enemyStyles from "../../../../styles/minigames/dragoninvaders/enemyStyles";

@customElement("enemy-dragon")
export class EnemyDragon extends LitElement {
    @property({type: Object}) private position: { x: number, y: number } = {x: 0, y: 0};
    @property({type: String}) private imageUrl: string = "";

    public static styles = [enemyStyles];

    protected render(): TemplateResult {

        return html`
            <div class="enemy"
                 style="transform: translate(${this.position.x}px, ${this.position.y}px); background-image: ${this.imageUrl}"></div>
        `;
    }

}
